import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import CheckIcon from '../../icons/CheckIcon';

import { getLangValue, getPhotoThumb } from '../../../utils/Generic';

const ExtrasBlock = (props, context) => {
  const {
    room, lang,
  } = props;

  // Initialize an object to store categorized extras
  const categorizedExtras = {};
  // Iterate through the extras array
  room.extras.forEach((extra) => {
    // Check if the category already exists in the categorizedExtras object
    if (!categorizedExtras[extra.category]) {
      // If the category doesn't exist, create a new array for it
      categorizedExtras[extra.category] = [];
    }
    // Push the extra to the corresponding category array
    categorizedExtras[extra.category].push(extra);
  });
  // Output the categorized extras

  // const extras = max ? room.extras.filter((item, index) => index < max) : room.extras;
  const hasExtras = room.extras.length > 0;

  if (!hasExtras) {
    return null;
  }
  return (
    <Fragment>
      {/* {!flat && renderHeader(context)} */}
      <div className="RoomKeySellingPoints">
        <div className="RoomHeader">
          {room.room.photos.length > 0 && getPhotoThumb({ url: room.room.photos[0].url, width: 80 })}
          <div className="RoomHeader__name">
            {getLangValue(room.room, lang, 'name').toLowerCase()}
          </div>
        </div>
        <p className="includesTitle">{context.t('Extras')}</p>
        <b className="ml-4">{categorizedExtras.transfer != null && context.t('Transportation')}</b>
        <ul className="keypoints">
          {categorizedExtras.transfer != null && categorizedExtras.transfer.map((extra, index) => (
            <li className="keypoints__item" key={`keypoint_${index}`}>
              {getLangValue(extra, lang, 'name')}
              <CheckIcon />
            </li>))}
        </ul>
        <b className="ml-4">{categorizedExtras.retreat != null && context.t('Tours and activities')}</b>
        <ul className="keypoints">
          {categorizedExtras.retreat != null && categorizedExtras.retreat.map((extra, index) => (
            <li className="keypoints__item" key={`keypoint_${index}`}>
              {getLangValue(extra, lang, 'name')}
              <CheckIcon />
            </li>))}
        </ul>
        <b className="ml-4">{categorizedExtras.extras != null && context.t('Extras')}</b>
        <ul className="keypoints">
          {categorizedExtras.extras != null && categorizedExtras.extras.map((extra, index) => (
            <li className="keypoints__item" key={`keypoint_${index}`}>
              {getLangValue(extra, lang, 'name')}
              <CheckIcon />
            </li>))}
        </ul>
      </div>
    </Fragment>
  );
};

ExtrasBlock.propTypes = {
  room: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  max: PropTypes.number,
  flat: PropTypes.bool,
};

ExtrasBlock.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default ExtrasBlock;
